/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Tip_DeadlineInputs */



/**
* | output |
* | --- |
* | "Any deadline, such as a fixture or vetting date" |
*
* @param {Contact_Tip_DeadlineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const contact_tip_deadline = /** @type {((inputs?: Contact_Tip_DeadlineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Tip_DeadlineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("任何截止日期，例如租约或审查日期")
	return /** @type {LocalizedString} */ ("Any deadline, such as a fixture or vetting date")
});